/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class PrPointCampaignEditor extends Common.GridEditorBase<PrPointCampaignRow> {
        protected getColumnsKey() { return "Points.PrPointCampaign"; }
        protected getDialogType() { return PrPointCampaignDialog; }
        protected getLocalTextPrefix() { return PrPointCampaignRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        
        }

        protected getButtons() {
            var buttons = super.getButtons();
        
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
        
        
            
            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            //opt.showFooterRow = true;
            //opt.showHeaderRow = false;
            opt.headerRowHeight = 0;
            // opt.frozenColumn = 1;
            return opt;
        }
    }
}